exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.entry-wrapper[data-v-126d66e6]{padding-bottom:12px;max-width:1140px;margin:0 auto 48px auto\n}\n@media(max-width: 769px){\n.entry-wrapper[data-v-126d66e6]{margin:0\n}\n}\n.entry-wrapper>div[data-v-126d66e6]{width:85%;display:block;margin:0 auto\n}\n.entry-wrapper h1[data-v-126d66e6]{font-weight:700;font-size:2.2rem;margin:48px 0 50px 0\n}\n.entry-wrapper hr[data-v-126d66e6]{margin:0;border:2px solid #fecc39;margin-bottom:36px;display:block;clear:both;width:55px\n}\n@media(max-width: 1024px){\n.entry-wrapper hr[data-v-126d66e6]{display:none\n}\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-126d66e6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Entry.vue
// module id = rjAD
// module chunks = 1